import React from 'react';
import css from './FilterSidebar.module.css';
import { Icons } from '../../../components';

const SearchInput = ({ value, onChange, placeholder = 'Search...', ...rest }) => {
  return (
    <div className={css.searchKeywordSec}>
      <Icons name="search" className={css.searchIcon} />
      <input
        type="text"
        className={css.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
};

export default SearchInput;
